var videoIntV2Form = (function () {
  return {
    init: init,
  };

  function init() {
    uiBindings();
  }

  function uiBindings() {
    var videoIntBtns = document.querySelectorAll('.open-video-integration-form'),
      modalContainer = document.querySelector('.video-int'),
      videoContainer = document.querySelector('.video-int__form .video-int__video-container iframe'),
      videoIntModal,
      videoId = '',
      closeMethod = 'cta';
      
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          closeMethod = 'escape';
        }
      });

    videoIntModal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: 'Close',
      cssClass: ['video-int__form'],
      onClose: function () {
        if (document.querySelector('.video-int__form .video-int__video-container iframe')) {
          document.querySelector('.video-int__form .video-int__video-container iframe').setAttribute('src', '');
        }
        videoIntModal.close();
        
        //Close Event
        WebEventTracker.logEvent(
          EDS.webEvents,
          'InteractedWithAppAutomateMarketingPage',
          bsLib.extend(
            {
              action: 'Video dismiss via ' + closeMethod,
              'cta-location': 'Demo_Modal',
            },
            ((popUpCSFOptions.vwoShow) ? {source:popUpCSFOptions.source} : {})
          )
        );
        closeMethod = 'cta';
      },
      beforeClose: function () {
        return true;
      },
    });

    videoIntModal.setContent(modalContainer.innerHTML);

    for (var i = 0; i < videoIntBtns.length; i++) {
      videoIntBtns[i].addEventListener(
        'click',
        function (evt) {
          evt.preventDefault();

          videoId = this.getAttribute('data-video-id');
          videoIntModal.open();

          var ua = navigator.userAgent.toLowerCase(),
              isSafari = false,
              sandboxFlag = '';
          try {
            isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
          } catch(err) {}

          isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
          sandboxFlag = isSafari ? '' : 'allow-presentation';

          
        var iframe = document.querySelector('.video-int__form .video-int__video-container iframe');
        if (iframe) {
          iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
          iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin ' + sandboxFlag);
          return;
        } else {
          iframe = document.createElement('iframe');
          iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
          iframe.setAttribute('width', '100%');
          iframe.setAttribute('height', '338px');
          iframe.setAttribute('frameborder', '0');
          iframe.setAttribute('allowfullscreen', true);
          iframe.setAttribute(
            'allow',
            'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          );
          iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin ' + sandboxFlag);

          var videoIntContent = document.querySelector('.video-int__form .video-int__video-container');
          if (videoIntContent) {
            videoIntContent.innerHTML = '';
            videoIntContent.appendChild(iframe);
          }
        }
          setUpFormButtons();
        },
        false
      );
    }
    function setUpFormButtons() {
      var formV2Btns = document.querySelectorAll('.video-int__form .video-int__btn');
      for (var i = 0; i < formV2Btns.length; i++) {
        formV2Btns[i].addEventListener(
          'click',
          function (evt) {
            evt.preventDefault();
            videoIntModal.close();
            if (videoContainer) {
              videoContainer.setAttribute('src', '');
            }
          },
          false
        );
      }
    }
  }
})();

videoIntV2Form.init();
